 /* topics will let the user add or edit a topic
  *
  *
  * Writers can only ADD topics.
  *
  * Editors can add topics (skipping approval) and also modify and approve topics that are not already approved.
  * Only not "claimed topics" can be updated by an editor.
  *
  * All users need to be able to search in the existing topics to be able to find similar topics
  *
  * ** topic need to be locked so that ppl don't claim a topic while someone is updating it.
  *
  *
  *
  * form should have :
  * Field : Title
  * Field : automatically filled intelligent search result using the title to find similar title.
  *
  * automatic fields should be :
  * - topic submission date
  * - topic submitter
  * - status : default "submitted" ( also:  "approved", "deasapproved", "claimed for article" )
  *
  *
  * ? POTENTIAL FIELD : note from editor, note from writer ?
  *
  *
  */
 import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
 import {
    XMLHttpRequestHandler,
     XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

 import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
 import { topicsEdit_template } from "../components/templates/topicsEdit_template";
 import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";


 declare var ko: any;
 declare var page: any;

 export class topics_edit extends vnModule_knockoutJS{

     protected XHRHdl: XMLHttpRequestHandler;
     protected formTemplate: topicsEdit_template;
     protected validationsList: validationsList_template;

     protected getModuleName(){
         return "topics_edit";
     }

     buildContent() : Array<Element>{

         // create validation errors list template
         this.validationsList = new validationsList_template("validationList", this.viewModel, this);

         // create the users list
         this.formTemplate = new topicsEdit_template("formTemplate", this.viewModel, this);

         return [this.validationsList.build(), this.formTemplate.build()];
     }

     fillPage() : void{

         this.getFormData();
     }

     protected getFormData(){

         this.loadingIn(this.formTemplate.builtTemplate);

         let id: number;
         let action: string;

         if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
             this.viewModel["formTemplate"].id(id);
         }


         let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/topic/data/' + id + "/";
         let usrReq_params: Array<Array<string>> = [];
         this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

         this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
         this.XHRHdl.execute();
     }

     // use the form data to fill the form
     protected onGetFormDataReturn(req, obj){

         return function(){
             if (req.request.readyState == 4) {

                 let thisModule = (<topics_edit>obj);
                 let responseParsed = JSON.parse(req.request.response);
                 if(  req.request.status == 200  ){

                     let topic = responseParsed.topic;

                     if(topic !== null) {
                         obj.formTemplate.updateForm(topic);
                     }

                     obj.loadingOut(obj.formTemplate.builtTemplate);

                     obj.validationsList.clearMessages();
                 }
                 else{
                     let msg = "error: while obtaining the form data - (" + req.request.status +")";
                     obj.validationsList.setSingleMessage({field: "error", "label": req.request.status, message: msg});
                     window.scrollTo(0, 0);

                 }
             }
         }
     }

     protected updateElementForm(topic, thisModule: topics_edit){
         thisModule.viewModel["formTemplate"].id(topic.id);
         thisModule.viewModel["formTemplate"].title(topic.title);
     }

     protected cancelEditTopic(){

         // redirect to earnings page or user list
         this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Topic creation canceled !");
         this.getVnAppZone().showNotificationToModule();
         page.redirect('/brand/' + this.getVnAppZone().getGlobal("idBrand") + '/topics/');

     }

     protected releaseLock(){
         // request a lock release
         let usrReq_url: string = '/api/brand/release/lock/' + this.getVnAppZone().app.params.id;
         let usrReq_params: Array<Array<string>> = [];
         // usrReq_params.push(["data", this.getVnAppZone().app.params.id] );
         this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
         this.XHRHdl.execute();
     }

     protected save() {

         let _this = this;
         let formReq_url: string = '/api/brand/' + this.getVnAppZone().getGlobal("idBrand") + '/topic/create';
         let formReq_params: Array<Array<string>> = [];

         let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

         formReq_params.push(["data", ko.toJSON(subViewModel)]);

         let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
         XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
         XHRHdl.onReadyStateFunction = (function (req, obj) {

             return function () {

                 if (req.request.readyState == 4) {

                     let accountsEditModule = (<topics_edit>obj);
                     let responseParsed = JSON.parse(req.request.response);

                     if (req.request.status == 200) {
                         // obj.releaseLock();

                         obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Topic saved successfully !");
                         obj.getVnAppZone().showNotificationToModule();
                         obj.validationsList.clearMessages();

                         page.redirect('/brand/' + this.getVnAppZone().getGlobal("idBrand") + '/topics/');
                     } else {
                         if (req.request.status == 400) {
                             obj.validationsList.setMessages(responseParsed.validations);
                             window.scrollTo(0, 0);
                         } else {
                             let msg = "error: while saving the data - (" + req.request.status + ")";
                             obj.validationsList.setSingleMessage({
                                 field: "error",
                                 "label": req.request.status,
                                 message: msg
                             });
                             window.scrollTo(0, 0);
                         }
                     }
                 }
             }
         });
         XHRHdl.execute();
     }

     protected getSimilarTopics(keyword)
     {
         if( this.XHRHdl ){
             this.XHRHdl.cancelAndReset();
         }

         let subViewModel = {
             keyword       : keyword
         };

         let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/topics/similar/';
         let usrReq_params: Array<Array<string>> = [];
         usrReq_params.push(["data", ko.toJSON(subViewModel)] );
         this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
         this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

         let localCheck = this.XHRHdl.requestId;
         let _myThis = this;
         setTimeout(function(){

             if( localCheck == _myThis.XHRHdl.requestId ){
                 _myThis.XHRHdl.onReadyStateFunction = _myThis.onSimilarTopicRequestReturn;
                 _myThis.XHRHdl.execute();
             }
         }, 400);
     }

     protected onSimilarTopicRequestReturn(req, obj){

         return function(){

             if (req.request.readyState == 4) {

                 let responseParsed = JSON.parse(req.request.response);

                 if(  req.request.status == 200  ){
                     obj.updateSimilarTopicsList(responseParsed);
                 }
                 else{
                     obj.onUpdateError(req.request.status, responseParsed);
                 }


                 // // LOADING : ends
                 // obj.loadingOut(obj.listTemplate.builtTemplate.children.namedItem("list-results"));
             }
         }
     }

     protected updateSimilarTopicsList(responseParsed: any){

         // set users list
         let topics = [];
         for (let item of responseParsed.topics) {

             topics.push( {
                 title: item.title
                 ,status: item.status
                 ,id: item.id
             } )
         }

         this.formTemplate.setSimilarTopics(topics);
     }
 }



// WEBPACK FOOTER //
// ./js/modules/topics_edit.ts